// extracted by mini-css-extract-plugin
export default {"wrapper":"rz-z","viewport":"sz-z","container":"tz-z","slide":"uz-z"};